export class ApiService {
  public options = {
    withCredentials: true,
  };

  public metadata = null;

  constructor(public server: string) {}
}
